import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  useMediaQuery,
  useTheme,
  Menu,
  MenuItem,
  useScrollTrigger,
  Slide,
  IconButton,
  Card,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import "@fontsource/poppins";
// import triangle from "../images/trangle-shape.png";
import BuildIcon from "@mui/icons-material/Build";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import CloudQueueIcon from "@mui/icons-material/CloudQueue";
import MemoryIcon from "@mui/icons-material/Memory";
import SecurityIcon from "@mui/icons-material/Security";
import men from "../images/Naren-CEO-CENSOFT-1.jpeg";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";
import { scroller } from "react-scroll";
import logo from "../images/logo.png";
import { useNavigation } from "../Context/NavigationContext";
import mdLogo from "../images/MD-Censoft.png"

const servicesList = [
  {
    id: 1,
    icon: <BuildIcon color="primary" />,
    title: "Application Services",
    description:
      "Custom software development, modernization, and integration services for business agility.",
  },

  {
    id: 2,
    icon: <SupportAgentIcon color="primary" />,
    title: "Managed Services",
    description:
      "End-to-end IT infrastructure support and maintenance to ensure uptime and performance.",
  },
  {
    id: 3,
    icon: <MemoryIcon color="primary" />,
    title: "AI & Data Science",
    description:
      "Unlock insights with advanced AI, ML models, and predictive analytics solutions.",
  },

  {
    id: 4,
    icon: <BusinessCenterIcon color="primary" />,
    title: "Business Consulting",
    description:
      "Strategic guidance to drive digital transformation and operational efficiency.",
  },
  {
    id: 5,
    icon: <CloudQueueIcon color="primary" />,
    title: "Cloud Solutions",
    description:
      "Scalable, secure cloud deployment and migration tailored to your enterprise needs.",
  },

  {
    id: 6,
    icon: <SecurityIcon color="primary" />,
    title: "Cybersecurity Solutions",
    description:
      "Comprehensive security frameworks to protect systems, data, and networks.",
  },
];

// Sample nav items
const navItems = [
  {
    label: "Home",
    path: "home",
  },
  {
    label: "About",
    path: "about",
  },
  {
    label: "Services +",
    path: "services",
  },
  {
    label: "Product",
    path: "products",
  },
  {
    label: "Contact Us",
    path: "locations",
  },
];

const HideOnScroll = ({ children }) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 50,
  });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
};

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [anchorEl, setAnchorEl] = React.useState(null);

  // const trigger = useScrollTrigger({ threshold: 0 });
  const navigate = useNavigate();
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const [atTop, setAtTop] = useState(true);
  const [servicesHover, setServicesHover] = useState(false);

  const IconGroup = () => (
    <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
      <FacebookIcon
        sx={{
          cursor: "pointer",
          color: "black",
          fontSize: { xs: 20, md: 25 },
          "&:hover": { color: "blue" },
        }}
      />
      <TwitterIcon
        sx={{
          cursor: "pointer",
          color: "black",
          fontSize: { xs: 20, md: 25 },
          "&:hover": { color: "#1DA1F2" },
        }}
      />
      <LinkedInIcon
        sx={{
          cursor: "pointer",
          color: "black",
          fontSize: { xs: 20, md: 25 },
          "&:hover": { color: "#0077b5" },
        }}
      />
      <InstagramIcon
        sx={{
          cursor: "pointer",
          color: "black",
          fontSize: { xs: 20, md: 25 },
          "&:hover": { color: "#e1306c" },
        }}
      />
    </Box>
  );
  // ✅ Detect scroll position exactly
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setAtTop(true); // exact top
      } else {
        setAtTop(false); // any scroll
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const { setScrollTarget } = useNavigation();

  const handleNavigateToSection = (path) => {
    console.log("pathname", path);
    if (window.location.pathname === "/") {
      scroller.scrollTo(path, {
        duration: 800,
        delay: 0,
        smooth: "easeInOutQuart",
        offset: -80,
      });
    } else {
      setScrollTarget(path); // Store the target in context
      navigate("/");
    }
  };

  const handleServiceClick = (id) => {
    navigate("/service#service-" + id);
  };

  return (
    <>
      {/* 👇 Top Promo Bar that hides on scroll */}
      <HideOnScroll>
        <AppBar
          position="static"
          elevation={0}
          sx={{
            background: `linear-gradient(to right, rgba(255, 192, 203, 1), rgba(173, 216, 230, 1))`, // browny red to dark blue
            height: { xs: 40, sm: 35 },
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Toolbar
            disableGutters
            sx={{
              minHeight: 50,
              width: "100%",
              px: 0,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
                px: 2,
              }}
            >
              {/* Center Text */}
              <Box
                sx={{
                  flexGrow: 1,
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: { xs: 0, md: 2 },
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: "black",
                    fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
                    fontFamily: "Poppins, sans-serif",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  Welcome to CENSOFT — Excellence Redefined!
                </Typography>
                {/* <IconGroup /> */}
              </Box>

              {/* Right Icon */}
            </Box>
          </Toolbar>
        </AppBar>
      </HideOnScroll>

      {/* 👇 Main Navbar that stays fixed */}
        <AppBar
          position="fixed"
          elevation={!atTop ? 5 : 0}
          sx={{
            top: 0,
            gap:1,
             minHeight: "clamp(60px, 8vw, 110px)",  
            zIndex: (theme) => theme.zIndex.appBar,
            color: "black",
            backgroundColor: !atTop ? "#fff" : "transparent",
            transform: !atTop ? "translateY(0)" : "translateY(50px)", // 👈 smooth Y-axis shift
            boxShadow: !atTop ? "0px 4px 20px rgba(0,0,0,0.08)" : "none",
            transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
            fontFamily: "Poppins",
            
          }}
        >
        <Toolbar
          sx={{
            justifyContent: "space-between",
            px: { xs: 2, sm: 4, md: 0, lg: 16 },
            mt: { xs: 0, sm: 0, md: 2, lg: 1 },
            pr : { xs: 0, sm: 0, md: 0, lg: 16 },
            fontFamily: "Poppins",
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontWeight: "bold",
              fontFamily: "Poppins",
              fontSize: {
                xs: "1.5rem",
                sm: "2rem",
                md: "2.2rem",
                lg: "2.5rem",
              },
              px: 1,
            }}
            color="primary"
          >
            <Link
              key="home"
              to="home"
              smooth={true}
              duration={500}
              offset={-80}
            >
              <Box
                onClick={() => handleNavigateToSection("home")}
                component="img"
                src={logo}
                alt="Logo"
                sx={{
                     width: "clamp(90px, 15vw, 190px)",  // min = 120px, fluid = 15vw, max = 190px
                    height: "clamp(60px, 8vw, 100px)",  // min = 60px, fluid = 8vw,  max = 100px
    
                  objectFit: "contain",
                  display: "block",
                  cursor: "pointer",
                }}
              />
            </Link>
          </Typography>

          {/* Navigation Items or Mobile Menu */}
          {isMobile ? (
            <>
              <IconButton onClick={handleMenuOpen} color="inherit">
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    smooth={true}
                    duration={500}
                    offset={-80}
                    onClick={handleMenuClose}
                  >
                    <MenuItem>{item.label}</MenuItem>
                  </Link>
                ))}
              </Menu>
            </>
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: { md: 1, lg: 0.5 },
              }}
            >
              {navItems.map((item) => {
                if (item.label === "Services +") {
                  return (
                    <Box
                      key={item}
                      sx={{ position: "relative" }}
                      // onMouseLeave={() => setServicesHover(false)}
                    >
                      <Link
                        key={item.path}
                        to={item.path}
                        smooth={true}
                        duration={500}
                        offset={-80}
                      >
                        <Button
                          to={item.path}
                          onClick={() => handleNavigateToSection(item.path)}
                          onMouseEnter={() => setServicesHover(true)}
                          sx={{
                            backgroundColor: "transparent",
                            color: "inherit",
                            fontWeight: 800,
                            fontFamily: "Poppins",
                            fontSize: { md: "14px", lg: "14px" },
                            borderRadius: 5,
                            minWidth: "120px",
                            textTransform: "none",
                            "&:hover": {
                              backgroundColor: "rgba(0,0,0,0.04)",
                            },
                          }}
                        >
                          {item.label}
                        </Button>
                      </Link>

                      {servicesHover && (
                        <Box
                          onMouseEnter={() => setServicesHover(true)}
                          onMouseLeave={() => setServicesHover(false)}
                          sx={{
                            position: "absolute",
                            top: "100%",
                            left: "50%",
			                      transform: "translateX(-50%)",
                            mt: 2,
                            width: "50rem",
                            display: "grid",
                            gridTemplateColumns: "1fr",
                            backgroundColor: "white",
                            boxShadow: 5,
                            borderRadius: 3,
                            zIndex: 999,
                            overflow: "hidden",
                          }}
                        >
                          {/* Services Section */}
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "repeat(2, 1fr)",
                              gap: 2,
                              px: 3,
                              py: 3,
                              backgroundColor: "#fff",
                            }}
                          >
                            {servicesList.map((service, i) => (
                              <Card
                                onClick={() => handleServiceClick(service.id)}
                                sx={{
                                  p: 2,
                                  borderRadius: 2,
                                  transition: "all 0.3s ease",
                                  cursor: "pointer",
                                  minHeight: 40,
                                  display: "flex",
                                  flexDirection: "column",
                                  "&:hover": {
                                    boxShadow: 3,
                                    transform: "translateY(-2px)",
                                  },
                                }}
                              >
                                {/* Icon and Title Row */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    mb: 1,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: 32,
                                      height: 32,
                                      borderRadius: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      mr: 1.5,
                                      color: "white",
                                      backgroundColor: "#c0d2f6",
                                    }}
                                  >
                                    {service.icon}
                                  </Box>
                                  <Typography
                                    sx={{
                                      fontWeight: 600,
                                      fontSize: "1.5rem",
                                    }}
                                  >
                                    {service.title}
                                  </Typography>
                                </Box>

                                {/* Description */}
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: "text.secondary",
                                    fontSize: "0.8rem",
                                    lineHeight: 1.4,
                                    mt: 1,
                                  }}
                                >
                                  {service.description}
                                </Typography>
                              </Card>
                            ))}
                          </Box>

                          {/* CEO Info Section */}
                          <Box
                            sx={{
                              background:
                                "linear-gradient(to bottom, #111, #222)",
                              color: "white",
                              px: 3,
                              py: 4,
                              display: "none",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              component="img"
                              src={men}
                              alt="CEO"
                              sx={{
                                width: 120,
                                height: 120,
                                borderRadius: "50%",
                                objectFit: "cover",
                                border: "2px solid white",
                              }}
                            />
                            <Typography
                              fontWeight="bold"
                              fontSize="1.1rem"
                              mb={1}
                            >
                              Meet Our CEO
                            </Typography>
                            <Typography
                              fontSize="0.85rem"
                              mb={2}
                              textAlign="center"
                            >
                              "CENSOFT is a premier Digital & IT solutions partner, accelerating enterprise transformation through innovation and cutting-edge technology. We empower businesses—from Fortune 500 leaders to startups—to optimize operations, elevate customer experiences, and drive scalable digital growth, exemplified by solutions like EAM, which revolutionizes asset management for peak efficiency.".
                            </Typography>
                          </Box>
                        </Box>
                      )}
                    </Box>
                  );
                }

                // All other nav items
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    smooth={true}
                    duration={500}
                    offset={-80}
                  >
                    <Button
                      onMouseLeave={() => setServicesHover(false)}
                      onClick={() => handleNavigateToSection(item.path)}
                      color="inherit"
                      sx={{
                        fontWeight: 800,
                        fontFamily: "Poppins",
                        fontSize: { md: "14px", lg: "14px" },
                        borderRadius: 5,
                        minWidth: "100px",
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: "rgba(0,0,0,0.04)",
                        },
                      }}
                    >
                      {item.label}
                    </Button>
                  </Link>
                );
              })}
            </Box>
          )}

          {/* CTA Button */}
          <Box 
          sx={{display:"flex",
            flexDirection:"row",
            alignItems:"center",
            gap : 2
          }}>
          <Link 
              key="contact"
              to="contact"
              smooth={true}
              duration={500}
              offset={-80}
          >
          <Button
            variant="contained"
             onClick={() => handleNavigateToSection("contact")}
            sx={{
              position: "relative",
              overflow: "hidden",
              backgroundColor: "#032262",
              color: "white",
              // width: { xs: 100, sm: 180, md: 180, lg: 150 },
              height: { xs: 40, md: 45, lg: 50 },
              px: 3,
              borderRadius: 3,
              fontFamily: "Poppins",
              fontSize: { xs: "0.75rem", md: "0.85rem", lg: "1rem" },
              textTransform: "none",
              // ml: { md: 2 },
              textWrap: "nowrap",
              zIndex: 1,
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                borderRadius: "10px",
                width: "100%",
                height: "100%",
                backgroundColor: "#a10304",
                transform: "translateY(100%)", // start below
                transition: "transform 0.3s ease-out",
                zIndex: -1, // behind text
              },
              "&:hover::before": {
                transform: "translateY(0)", // slide in from bottom
              },
              "&:hover": {
                color: "white",
              },
            }}
          >
            Let's talk 💬
          </Button>
          </Link>
           <Box
                onClick={() => handleNavigateToSection("home")}
                component="img"
                src={mdLogo}
                alt="Logo"
                sx={{
                    width: "clamp(90px, 15vw, 190px)",  // min = 120px, fluid = 15vw, max = 190px
    height: "clamp(60px, 8vw, 100px)",  // min = 60px, fluid = 8vw,  max = 100px
    
                  objectFit: "contain",
                  display: "block",
                  cursor: "pointer",
                }}
              />

          </Box>
          
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Header;
